// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';

// Material Kit 2 React examples
import RotatingCard from 'examples/Cards/RotatingCard';
import RotatingCardFront from 'examples/Cards/RotatingCard/RotatingCardFront';
import RotatingCardBack from 'examples/Cards/RotatingCard/RotatingCardBack';

// Images
import carox from 'assets/csdd_images/car_x_final.png';
import { Handshake } from '@mui/icons-material';

import gips_logo from 'assets/csdd_images/GIPS-Logo-3.jpg';
import prosupp_logo from 'assets/csdd_images/prosuppImage.jpeg';

function Partners() {
  return (
    <MKBox component='section' py={6} my={6}>
      <Container>
        <Grid
          container
          item
          xs={11}
          spacing={3}
          alignItems='center'
          sx={{ mx: 'auto' }}
        >
          <Grid item xs={12} lg={4} sx={{ mx: 'auto' }}>
            <RotatingCard>
              <RotatingCardFront
                color='warning'
                image={carox}
                icon={<Handshake />}
                title={
                  <>
                    Our
                    <br />
                    Partners
                  </>
                }
                description='We work and collaborate with organizations and institutions across the procurement and supply chain space.'
              />
              <RotatingCardBack
                color='warning'
                image={carox}
                title='Become a Partner'
                description='Our goal is to nurture an environment where integrity and best practices in procurement are the norms, and facilitate the development and diversity of suppliers, thereby contributing to the sustainable economic development of Ghana.'
                action={{
                  type: 'internal',
                  route: '/contact-us',
                  label: 'work with us',
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: 'auto' }}>
            <Container
              sx={{
                backgroundColor: '#fff',
                borderRadius: 5,
                textAlign: 'center',
              }}
            >
              <Grid
                container
                justifyContent='center'
                spacing={3}
                py={3}
                sx={{ mt: 1, mb: 12 }}
              >
                <Grid item xs={12} md={6}>
                  <MKBox
                    component='img'
                    src={gips_logo}
                    alt='Logo of GIPS partner'
                    width='50%'
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <MKBox
                    component='img'
                    src={prosupp_logo}
                    alt='Logo of Prosupp consult partner'
                    width='50%'
                  />
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Partners;
